<template>
  <!-- Price Modal -->
  <div
    class="modal pricemodal fade"
    :id="'priceModal-'+index"
    tabindex="-1"
    role="dialog"
    aria-labelledby="priceLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h6
            class="modal-title"
            id="exampleModalLabel"
												data-test="priceModalHead"
          >
            Enter Quantity
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
												data-test="priceModalCloseBtn"
												id="priceModalCloseBtn"
          >
            <span aria-hidden="true" data-test="priceModalCloseSpan"
																		id="priceModalCloseSpan">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="input-group input-group-sm mb-3">
            <input
              type="number"
              class="form-control"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
              v-model="showQuantity"
														data-test="priceModalAmtInput"
														id="priceModalAmtInput"
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm border-r"
            data-dismiss="modal"
												data-test="priceModalCancelBtn"
												id="priceModalCancelBtn"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-type-primary btn-sm"
            @click.prevent="showMoreQuantity"
												data-test="priceModalSaveBtn"
												id="priceModalSaveBtn"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Price Modal -->
</template>

<script>
export default {
	name: 'price-modal',
	data () {
		return {
			showQuantity: 0
		}
	},
	mounted () {
		this.showQuantity = this.productQuantity
	},
	props: {
		max_quantity: null,
		productId: null,
		stock: {
			default: 0,
			type: Number
		},
		index: {
			default: 0,
			type: Number
		},
		productQuantity: {
			default: 0,
			type: [Number, String]
		}
	},
	methods: {
		showMoreQuantity () {
			if (this.showQuantity > this.max_quantity || this.showQuantity > this.stock) {
				this.$toasted.show(`You can buy only ${(this.max_quantity > this.stock) ? this.stock : this.max_quantity} units of this product`)
			} else {
				$(`#priceModal-${this.index}`).modal('hide')
				this.$emit('quantityChanged', this.showQuantity)
			}
		}
	},
	watch: {
		productQuantity () {
			this.showQuantity = this.productQuantity
		}
	}
}
</script>

<style scoped>
</style>
